import _extends from "@babel/runtime-corejs3/helpers/extends";
import React, { useContext, useMemo } from 'react';
import { StylesContext } from '../context/styles';
import { getStyleUtil } from '../utils';
export function useStyles(directStyles, name, propStyles) {
  var context = useContext(StylesContext);

  var _ref = context || {},
      components = _ref.components,
      tokens = _ref.tokens;

  var styleUtil = useMemo(function () {
    return getStyleUtil({
      directStyles: directStyles,
      propStyles: propStyles,
      name: name,
      components: components,
      tokens: tokens
    });
  }, [components, directStyles, name, propStyles, tokens]);
  return styleUtil;
}

var styled = function styled(styles) {
  return function (WrappedComponent) {
    var name = WrappedComponent.name || WrappedComponent.displayName;

    function StyledInner(props) {
      var styleUtil = useStyles(styles, name, props.styles);
      return /*#__PURE__*/React.createElement(WrappedComponent, _extends({}, props, {
        styles: styleUtil
      }));
    } // HACK: apparently some third party components (i.e. airbnb's DatePicker) execute
    // functional components as functions, which breaks hooks, so we wrap the functional
    // component in another functional component to get around it here 🙈


    function Styled(props) {
      return /*#__PURE__*/React.createElement(StyledInner, props);
    }

    Styled.displayName = "styled(".concat(name, ")");
    return Styled;
  };
};

export default styled;